import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: 8,
    boxShadow: theme.shadows[16],
    background: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  actionSection: {
    display: 'flex',
    gridColumn: '1/3',
    gridRow: '3',
    padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(3)}`,
    borderTop: `1px solid ${theme.palette.border.light}`,
    justifyContent: 'space-between',
  },
  buttonSection: {
    '& > button + button': {
      marginLeft: theme.spacing(2),
    },
  },
  actionButtons: {
    padding: `0px ${theme.spacing(3)}`,
  },
  defaultSection: {
    display: 'flex',
    alignItems: 'center',
    '& > p + div': {
      marginLeft: theme.spacing(1),
    },
  },
  toolbarSection: {
    display: 'flex',
    gridColumn: '2/3',
    gridRow: '1',
    padding: theme.spacing(2),
  },
  datesContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '80px',
    alignItems: 'baseline',
    '& > div + div': {
      marginLeft: theme.spacing(2),
    },
    margin: `${theme.spacing(2)} ${theme.spacing(2)} 0 ${theme.spacing(2)}`,
    '& .MuiTextField-root': {
      flex: 1,
    },
  },
  dateRangeType: {
    color: theme.palette.text.primary,
    fontSize: '16px',
    alignSelf: 'center',
  },
  dateRangeContainer: {
    display: 'inline-flex',
    '& > .MuiButton-root + .MuiTypography-root, .MuiSelect-select + .MuiTypography-root': {
      marginLeft: theme.spacing(1.5),
    },
  },
  buttonSelect: {
    textTransform: 'capitalize',
    fontWeight: '400',
    fontSize: '16px',
    borderRadius: '12px',
    height: '45px',
    // padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
    border: `1px solid ${theme.palette.border.main}`,
    color: `${theme.palette.text.primary}`,
    '&.compact': {
      maxHeight: '40px',
      fontWeight: '500',
      borderRadius: '12px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      fontSize: '0.875rem',
      fontFamily: 'Rubik',
      lineHeight: '1.75',
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
    },
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus': {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.background.default,
    },
  },
  defaultSelect: {
    textTransform: 'none',
    fontWeight: '400',
    fontSize: '16px',
    borderRadius: '12px',
    minWidth: '160px',
    padding: 'none',
    // border: `1px solid ${theme.palette.border.light}`,
    color: `${theme.palette.text.primary}`,
    margin: `0px ${theme.spacing(1)}`,
    '& .MuiSelect-select': {
      padding: `${theme.spacing(1.25)} ${theme.spacing(1.5)}`,
    },
  },
  menuItem: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.main,
    },
  },
  shortcutContainer: {
    gridColumn: 1,
    gridRow: 2,
    borderRight: `1px solid ${theme.palette.border.light}`,
    padding: `${theme.spacing(2)}`,
    '& [sharedcomponentid="Q_CHOICE_CHIPS"]': {
      gap: theme.spacing(0.5),
    },
    '& div': {
      display: 'flex',
      flexDirection: 'column',
    },
    '& .MuiChip-outlined': {
      border: 'none',
      alignItems: 'flex-start',
      margin: 0,
      borderRadius: '9px',
      fontSize: '16px',
      padding: '8px',
      height: 'auto',
    },
    '& .MuiChip-selected': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.main,
    },
  },
  staticDatePicker: {
    border: '10px solid',
  },
  datePickerPopover: {
    '.MuiChip-root': {
      flexGrow: 1,
      background: 'none',
      align: 'flex-start',
      justifyContent: 'flex-start',
      borderRadius: '8px',
      margin: 0,
    },
    '.MuiChip-label': {
      ...theme.typography.body1,
      lineHeight: theme.spacing(2.5),
    },
    '.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
      backgroundColor: theme.palette.action.hover,
      '&:last-of-type': {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
      },
      '&:first-of-type': {
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
      },
    },
    '.MuiDateRangePickerDay-hiddenDayFiller': {
      visibility: 'hidden',
    },
    '.MuiDateRangePickerDay-startOfMonth.MuiDateRangePickerDay-firstVisibleCell': {
      borderTopLeftRadius: '0px',
      borderBottomLeftRadius: '0px',
    },
    '.MuiDateRangePickerDay-endOfMonth.MuiDateRangePickerDay-lastVisibleCell': {
      borderTopRightRadius: '0px',
      borderBottomRightRadius: '0px',
    },
    '.Mui-selected': {
      borderRadius: '8px',
    },
    '.MuiPickersDay-today': {
      borderTopLeftRadius: '8px',
      borderBottomLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderBottomRightRadius: '8px',
      border: `1px solid ${theme.palette.primary.main} !important`,
    },
    '.MuiPickersArrowSwitcher-button > svg': {
      border: `1px solid ${theme.palette.border.light}`,
    },
    '.MuiDateRangePickerDay-rangeIntervalDayPreview': {
      '&:last-of-type': {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
      },
      '&:first-of-type': {
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
      },
    },
    '.MuiDateRangePickerDay-dayOutsideRangeInterval:hover': {
      borderRadius: '8px',
    },
    '.MuiSelect-select': {
      minWidth: '140px',
      color: theme.palette.text.primary,
    },
    '.MuiDateRangeCalendar-monthContainer:not(:last-of-type)': {
      borderRight: 'none',
    },
    '.MuiDateRangePickerDay-dayInsideRangeInterval': {
      opacity: 1,
    },
  },
  selectedRangeInput: {
    border: `3px solid ${theme.palette.primary.main}`,
    borderRadius: '4px',
    backgroundColor: `${theme.palette.primary.light}`,
  },
  clearDateIcon: {
    fontSize: '16px !important',
  },
}));

export default useStyles;
